// extracted by mini-css-extract-plugin
export default {"optionsContainer":"LyTeC","optionsContainerDesktop":"fIM9Z"};